import { InjectionToken } from '@angular/core';

export const HIPPO_CONFIG = new InjectionToken<any>('HIPPO_APP_CONFIG');
